import React from "react";
import moment from "moment";
import { connect } from "react-redux";

import { goTo } from "../../tools";
import { movil } from "../../app-movil";
import { database } from "../../app-database";
import { descargarDocumento, descargarCertificadoAzul, descargarCertificadoEco } from "../../home/polizas.act";
import { nombreProductoGM, getNumPoliza, isSantander } from "../../common/logica";
import PagoPoliza from "../../home/pago.cmpt.js";
import {obtenerSumaDentalia,PermisosAsistenciaDental } from '../../home/dentalia.act';


const mapState = (state) => {
	return {
		"polizasCargadas": state.polizas.polizasCargadas,
		"loading": state.global.loading,
		"poliza": state.polizas.poliza,
		"ts": state.polizas.ts,
		"callTs": state.polizas.callTs,
		"timeout": state.polizas.inactividad,
		pagoPorKilometro: state.polizas.pagoPorKilometro,
		dispositivo: state.global.dispositivo,
		//SumaDentalia:state.polizas.SumaDentalia,
		PermisoDentalia:state.polizas.PermisoDentalia
	};
};

const mapDispatch = (dispatch) => {
	return {
		cerrarDetalle: () => {
			dispatch({ "type": "REINICIAR_CONTADOR_DETALLE_MOVIL" });
			dispatch({ "type": "IDENTIDAD_MOVIL_INVALIDA" });
			dispatch({ "type": "CERRAR_DETALLE_MOVIL" });
		},
		actualizaTouchId: () => {
			dispatch({ "type": "REINICIAR_CONTADOR_DETALLE_MOVIL" });
		},
		descargarCertificadoECO: (sPoliza, sCertificado) => {
			dispatch(descargarCertificadoEco(sPoliza, sCertificado, true));
		},
		descargarCertificado: (sPoliza, sCertificado) => {
			dispatch(descargarCertificadoAzul(sPoliza, sCertificado, true));
		},
		regresar: () => {
			dispatch({ "type": "IDENTIDAD_MOVIL_INVALIDA" });
			dispatch({ "type": "CERRAR_DETALLE_MOVIL" });
		},
		descargarDocumento: (sDocumento, sPoliza, sVersion, sRecibo, bMovil) => {
			dispatch(descargarDocumento(sDocumento, sPoliza, sVersion, sRecibo, bMovil));
		},
		mostrarErrorSesion: () => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Importante", "mensaje": "Has excedido el tiempo de visualización de la póliza. Para poder acceder a ella se te solicitará verificar tu identidad." });
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		},
		setRecibo: (oRecibo) => {
			dispatch({ "type": "SET_RECIBO_PAGAR", "recibo": oRecibo });
		},
		addEvento: (evento) => {
			dispatch({ "type": "HOME_SET_EVENT", "evento": evento });
		},
		/*obtenerSumaDentalia : (sumaPoliza)=>{
			dispatch(obtenerSumaDentalia(sumaPoliza));
		},*/
		PermisosAsistenciaDental : (PermisoProductivo,PermisoComercial)=>{
			dispatch(PermisosAsistenciaDental(PermisoProductivo,PermisoComercial));
		}
	};
};

class Detalle extends React.Component {

	state = {
		"vigencia": "0%",
		"poliza": false,
		"vigencia": false,
		"servicios": false,
		"descargas": false,
		"cargaCompleta": false,
		"colorVigencia": "#DBE4F0",
		"showServicios": false,
		verPago: false,
		"productoAetna": false,
		"polizasMedicaMovil": false
	}

	componentDidMount(){
		database.ref("aetna_gmm/").on("value", (snapshot)=> {
			const validaciones = snapshot.val();
			let banderaProductoAetna = null;
			validaciones.map(validacion => {
				if (validacion.cve_prod_comercial===this.props.poliza.generales.cveProdComercial && 
					validacion.cve_prod_tecnico===this.props.poliza.generales.cveProdTecnico){
						banderaProductoAetna = true;
				}
			});
			if(banderaProductoAetna !== null){
				this.setState({ "productoAetna" : banderaProductoAetna })		
			}
		});
	}

	componentWillMount = () => {
		//this.props.obtenerSumaDentalia(this.props.poliza.generales.numPoliza);

		this.props.PermisosAsistenciaDental(this.props.poliza.generales.cveProdTecnico, this.props.poliza.generales.cveProdComercial);

	}

	seccionVisible = (sTipo, sNombre) => {
		let bCondiciones = false;
		if (this.props.poliza.links) {
			this.props.poliza.links.map((item) => {
				if (item.tipo == sTipo && item.nombre == sNombre) {
					bCondiciones = true;
				}
			});
		}

		if (sNombre == "poliza" && sTipo == "link" && this.props.poliza.generales.cveSistema == "AZUL") {
			bCondiciones = (this.props.poliza.asegurados.filter(asegurado => asegurado.banderaTitular == 1).length > 0);
		}

		return bCondiciones;
	}

	mostrarPagar = () => {
		let { cveProdComercial, cveProdTecnico } = this.props.poliza.generales;

		if (cveProdComercial === "00003" && cveProdTecnico === "G0334SEGMA") {
			return false;
		}
		return true;
	}

	goToPago = (event) => {
		console.log("quiero ir a la pantalla de pago")
		event.preventDefault();
	}

	showPago = (event) => {
		console.log("quiero pagar desde movil");
		event.preventDefault();
		if (
			this.props.polizasCargadas &&
			!(this.props.poliza.generales.cveProdComercial == "00012" && this.props.poliza.generales.cveProdTecnico == "A2400FLOT") && // AUTO MAS
			!(this.props.poliza.generales.cveProdComercial == "00002" && this.props.poliza.generales.cveProdTecnico == "V1011PFLVM") && // VIDA MAS
			!(this.props.poliza.generales.cveProdComercial == "00003" && this.props.poliza.generales.cveProdTecnico == "V1011PFLVM") // VIDA MAS INCREMENTO
		) {
			this.props.addEvento("BtnPagar");
			if (this.props.poliza.cobranza && this.props.poliza.cobranza.registros && this.props.poliza.cobranza.registros.length > 0) {
				let aRecibos = this.props.poliza.cobranza.registros.sort(function (a, b) { return b.codNumRecibo.localeCompare(a.codNumRecibo); });
				let oRecibo = aRecibos[aRecibos.length - 1];

				this.props.setRecibo(oRecibo);
			}

			this.setState({
				verPago: !this.state.verPago,
			});
		}
		this.setState({
			verPago: true,
		});
	}

	cargarImagen = (sImagen) => {
		var state = {};
		state[sImagen] = true;
		this.setState(state);
	}

	getDeviceType() {

		if (typeof window.webkit != 'undefined' && window.webkit.messageHandlers) return "iOS";
		if (typeof android_conectam != 'undefined') return "android";
		return "browser";

	}

	verDetallePagoPorKM = () => {

		let enable = this.props.pagoPorKilometro[this.props.poliza.generales.numPoliza].isStartKmCaptured;

		if (!enable) {

			this.props.tagManager({
				type: 'EVENT_CLICK_REGISTRAR-PAGO-POR-KM',
				dispositivo: this.props.dispositivo
			});

		}

		goTo('movil/detalle/pagoPorKM')
	}

	verDetallePagoPorKMFinal = ( textoPagoPorKilometroFinal ) => {

		let enable = this.props.pagoPorKilometro[this.props.poliza.generales.numPoliza].isStartKmCaptured;
		
		if( textoPagoPorKilometroFinal === 'Consulta tu km final' && !this.props.pagoPorKilometro[this.props.poliza.generales.numPoliza].banRevision ){
			goTo('/movil/detalle/consultaKMFinal')
		} else {
			goTo('movil/detalle/pagoPorKMFinal');
			this.props.tagManager({
				type: 'EVENT_CLICK_REGISTRO_KM-FINAL',
				dispositivo: this.props.dispositivo
			});
		}
	}


	mostrarPantalla = () => {
		if (!this.state.cargaCompleta) {
			var _this = this;
			var ini = moment(this.props.poliza.generales.fchVigenciaInicial, "DD/MM/YYYY").valueOf();
			var fin = moment(this.props.poliza.generales.fchVigenciaFinal, "DD/MM/YYYY").valueOf();
			var now = moment().valueOf();

			var color = "#183D7B", vigencia = "90%";

			if (now > fin) {
				color = "#FF6F20";
				vigencia = "100%";
			}

			if (now < fin) {
				vigencia = (((now - ini) * 100) / (fin - ini)) + "%";
			}

			setTimeout(() => {
				$(".contenedor-detalle").addClass("contenedor-detalle-visible");
			}, 300);
			setTimeout(() => {
				$(".detalle-poliza").addClass("detalle-poliza-visible");
			}, 500);
			setTimeout(() => {
				$(".titulo-detalle").addClass("titulo-detalle-visible");
			}, 700);
			setTimeout(() => {
				$(".botones-detalle").addClass("botones-detalle-visible");
			}, 900);
			setTimeout(() => {
				_this.setState({ "vigencia": vigencia, "colorVigencia": color, "cargaCompleta": true });
				_this.props.actualizaTouchId();
			}, 1200);
		}
	}

	toggleServicios = () => {
		if (this.validaInactividad()) {
			this.setState({
				"showServicios": !this.state.showServicios
			});
		}
	}

	verPdf = () => {
		let mensajePdf = ({ "return": "detallePoliza", "proceso": "descargaApp", "numPoliza": this.props.poliza.generales.numPoliza, "numVersion":this.props.poliza.generales.numVersion, "ramoPoliza":this.props.poliza.generales.cveRamo, "name": "callbackHandler" });
		if (this.validaInactividad()) {
			if (this.props.poliza.generales.cveSistema == "AZUL") {
				let asegurado = this.props.poliza.asegurados.filter(aseg => aseg.banderaTitular == 1);
				let certificado = "";
				if (asegurado.length > 0) {
					certificado = asegurado[0].certificado;
				} else {
					certificado = this.props.poliza.asegurados[0].certificado;
				}
				this.props.descargarCertificado(this.props.poliza.generales.numPoliza, certificado);
			} if (this.props.poliza.generales.cveSistema == "ECO") {
				let asegurado = this.props.poliza.asegurados.filter(aseg => aseg.banderaTitular == 1);
				let certificado = "";
				if (asegurado.length > 0) {
					certificado = asegurado[0].certificado;
				} else {
					certificado = this.props.poliza.asegurados[0].certificado;
				}

				this.props.descargarCertificadoECO(certificado,this.props.poliza.generales.numPoliza);
			} else {
				if (this.props.dispositivo == "web") {
					this.props.descargarDocumento("poliza", this.props.poliza.generales.numPoliza, this.props.poliza.generales.numVersion, "", true);
				} else {
					movil("descargaApp", mensajePdf);
				}
			}
		}
	}

	/**se agrega para las validaciones de medica movil 230910 */
  
	verServiciosMM = () =>{
		let mensajeSMM = ({ "return": "detallePoliza", "proceso": "opcionesSMM","name": "callbackHandler" });
		if (this.validaInactividad()) {
			movil("opcionesSMM", mensajeSMM);
		}
	}


	verAsistenciaDental = () =>{
		let mensajeSMM = ({ "return": "detallePoliza", "proceso": "opcAsistenciaMedica", "numPoliza": this.props.poliza.generales.numPoliza, "ramoPoliza":this.props.poliza.generales.cveRamo, "name": "callbackHandler" });
		if (this.validaInactividad()) {
			movil("opcAsistenciaMedica", mensajeSMM);
		}
	}

	verHome = () => {
		if (this.validaInactividad()) {
			this.props.cerrarDetalle();
			goTo("movil/polizas");
			//window.location.href = "/#!/movil/polizas";
		}
	}

	validaInactividad = () => {
		if (new Date() > new Date(this.props.callTs + this.props.timeout)) {
			this.props.mostrarErrorSesion();
			this.props.regresar();
			goTo("movil/polizas");
			//window.location.href = "/#!/movil/polizas";
			return false;
		} else {
			this.props.actualizaTouchId();
			return true;
		}
	}
	policyStartDateIsFuture = (date) => {

		let currentDate = moment().format('DD/MM/YYYY');		
		let fechaFutura = moment(date, 'DD/MM/YYYY').add(14, 'd').format('DD/MM/YYYY');

		return (moment(fechaFutura, 'DD/MM/YYYY').diff(moment(currentDate, 'DD/MM/YYYY'),'d') <= 14) ? false : true;


	}

	render() {
		let ramo = this.props.poliza.generales.cveRamo;
		let cveProdTecnico = this.props.poliza.generales.cveProdTecnico;
		let cveProdComercial = this.props.poliza.generales.cveProdComercial;
		let telPagar, telConsultar, telSiniestros,telAetnaEua,telAetnaResto;

		if((cveProdTecnico==="G0334GMMII") && (cveProdComercial ==="00001" || cveProdComercial ==="00002" ||cveProdComercial ==="00005" ||cveProdComercial ==="00006" ||cveProdComercial ==="00008" ||cveProdComercial ==="00009" || cveProdComercial ==="00010"))
		{
			telPagar = "5552279002";
			telConsultar = "5552279002";
			telSiniestros = "5552279002";
			telAetnaEua = "+18772483611";
			telAetnaResto= "+18137750452";
			
		}else{
			switch (ramo) {
				case "D":
					telPagar      = "5552273999,890175";
					telConsultar  = "5552273999,890174";
					telSiniestros = "5552273999,890174";
					break;
				case "G":
					telPagar      = "5552273999,890175";
					telConsultar  = "5552273999,890172";
					telSiniestros = "5552273999,890172";
					telAetnaEua = "+18772483611";
					telAetnaResto= "+18137750452";
					break;
				case "V":
					telPagar      = "5552273999,890175";
					telConsultar  = "5552273999,890173";
					telSiniestros = "5552273999,890173";
					break;
				case "A":
					telPagar      = "5552273999,890175";
					telConsultar  = "5552273999,890171";
					telSiniestros = "5552273999,890170";
					break;
				}
			}


		if (this.state.poliza && this.state.vigencia && this.state.servicios && (isSantander(this.props.poliza) || this.state.descargas) && !this.state.cargaCompleta) {
			this.mostrarPantalla();
		}

		var textoPagoPorKilometro = "Registra tu km inicial";
		var textoPagoPorKilometroFinal = "";
		var isEndKmCaptured = false;
		var enableFinalCapture = false;
		var candidate = false;
		var enabled = false;
		if (typeof this.props.pagoPorKilometro[this.props.poliza.generales.numPoliza] != 'undefined') {

			const kilometroPoliza = this.props.pagoPorKilometro[this.props.poliza.generales.numPoliza];
			candidate = kilometroPoliza.candidate;			
			textoPagoPorKilometro = kilometroPoliza.isStartKmCaptured || !kilometroPoliza.enabled ? 'Consulta tu km inicial' : 'Registra tu km inicial';
			if (!kilometroPoliza.enabled && !kilometroPoliza.isStartKmCaptured) {
				candidate = false;
			}
		}
		if (typeof this.props.pagoPorKilometro[this.props.poliza.generales.numPoliza] != 'undefined') {
			const kilometroPoliza = this.props.pagoPorKilometro[this.props.poliza.generales.numPoliza];
			textoPagoPorKilometroFinal = kilometroPoliza.isEndKmCaptured ? 'Consulta tu km final' : 'Registra tu km final';
			isEndKmCaptured = kilometroPoliza.isEndKmCaptured;
			enableFinalCapture = kilometroPoliza.enableFinalCapture;
		}


		return (
			// <div className="polizas-mobile">
			<div>
				<div className="container">
					{/* <img onClick={this.verHome} className="detalle-back-arrow" src={require("../../img/arrow-back.svg")} /> */}
					{this.state.verPago &&
						<PagoPoliza showPago={this.showPago} />
					}
					{/* {!this.state.verPago && */}
					{true &&
						// <div className="box-wrap">
						<div>
							{/* <div className="cards-wrap mt-25 contenedor-detalle"> */}
							<div>
								<div className="row">
									<div className="card card-shadow" style={{ "margin": "5% auto 0 auto", "width": "90%", "position": "relative" }} aria-hidden="false">
										<div className="detalle-poliza">
											<div className="clearfix no-poliza-movil">
												<div className="pull-left">
													{/* <p><img src={require("../../img/icon-poliza.png")} onLoad={this.cargarImagen.bind(this, "poliza")} alt="" /><b>No. Póliza: {getNumPoliza(this.props.poliza)}</b></p> */}
													<p><img src={require("../../img/icon-poliza.png")} onLoad={this.cargarImagen.bind(this, "poliza")} alt="" /><b>No. Póliza: 3456278923</b></p>
												</div>
												<div className="pull-right">
													<p className="no-margin"><b className="orange-text"></b></p>
												</div>
											</div>
											<p className="gray-text texto-12"><i><img src={require("../../img/page_1_copy_2.svg")} onLoad={this.cargarImagen.bind(this, "vigencia")} alt="" /></i>Vigencia</p>
											<div id="status-gris">
												<div id="status-verde" style={{ "width": this.state.vigencia, "backgroundColor": this.state.colorVigencia }}>
												</div>
											</div>
											<div className="row">
												{/* <div className="col-xs-6 text-left"><small className="text10">{this.props.poliza.generales.fchVigenciaInicial}</small></div> */}
												<div className="col-xs-6 text-left"><small className="text10">15/04/2019</small></div>
												{/* <div className="col-xs-6 text-right"><small className="text10">{this.props.poliza.generales.fchVigenciaFinal}</small></div> */}
												<div className="col-xs-6 text-right"><small className="text10">16/04/2020</small></div>
											</div>
											<div className="clearfix">
												<p style={{ "fontSize": "5px" }}>&nbsp;</p>
												<div className="pull-left">
													<p className="no-margin texto12">Producto:</p>
												</div>
												<div className="pull-right">
													{/* {ramo == "G" &&
														<p className="no-margin texto12"><b>{nombreProductoGM(this.props.poliza)}</b></p>
													}
													{ramo == "A" &&
														<p className="no-margin texto12"><b>{this.props.poliza.generales.productoNegocio}</b></p>
													}
													{(ramo == "V" || ramo == "D") &&
														<p className="no-margin texto12"><b>{this.props.poliza.generales.productoComercial}</b></p>
													} */}
													
														<p className="no-margin texto12"><b>{this.props.poliza.generales.productoNegocio}</b></p>
													
												</div>
											</div>
										</div>
										<div className="header-card-mobile pd-10 titulo-detalle" >
											{/* {ramo == "A" &&
												<div className="title-icon">
													<p>Modelo - {this.props.poliza.vehiculo.modelo}</p>
													<p>{this.props.poliza.vehiculo.descripcion}</p>
												</div>
											}
											{ramo == "G" &&
												<div className="title-icon">
													<h3 className="">{(this.props.poliza.contratante) ? ("Asegurado: " + this.props.poliza.contratante.nombres + " " + this.props.poliza.contratante.apellidoPaterno + " " + this.props.poliza.contratante.apellidoMaterno) : ("")}</h3>
												</div>
											}
											{ramo == "V" &&
												<div className="title-icon">
													<h3 className="">{(this.props.poliza.contratante) ? ("Asegurado: " + this.props.poliza.contratante.nombres + " " + this.props.poliza.contratante.apellidoPaterno + " " + this.props.poliza.contratante.apellidoMaterno) : ("")}</h3>
												</div>
											}
											{ramo == "D" &&
												<div className="title-icon">
													<h3 className="">{(this.props.poliza.contratante) ? ("Asegurado: " + this.props.poliza.contratante.nombres + " " + this.props.poliza.contratante.apellidoPaterno + " " + this.props.poliza.contratante.apellidoMaterno) : ("")}</h3>
												</div>
											} */}
											{true &&
												<div className="title-icon">
													{/* <p>Modelo - {this.props.poliza.vehiculo.modelo}</p> */}
													<p>Modelo - 2015</p>
													{/* <p>{this.props.poliza.vehiculo.descripcion}</p> */}
													<p>JETTA NUEVO 2.0L TIPTRONIC</p>
												</div>
											}
										
										</div>
										{
											// this.getDeviceType() != "browser" && //Este ya estaba comentado
											// candidate
											// && (this.props.poliza.generales.claveRol == 'TOM' || this.props.poliza.generales.claveRol == 'COH') &&
											// !this.policyStartDateIsFuture(this.props.poliza.generales.fchVigenciaInicial) &&
											true &&
											<div>
												<div className="row">
													<div className="col-xs-4">
														<img className="img-responsive center-block" src={require('../../img/smart-trip.png')} />
													</div>
													<div className="col-xs-8" style={{ "marginLeft": "-20px", "width": "70.66667%", "text-align": "center" }}>
														<p><b>En GNP reconocemos tu compromiso con el medio ambiente</b></p>
														{/* <p style={{ marginBottom: "0px" }}><b>Distintivo bajo kilometraje</b></p> */}
														<p style={{ "fontSize": "12px" }}>Con Distintivo bajo kilometraje puedes obtener una bonificación 
														si recorres menos de 7,000 km anuales.</p>
													</div>
												</div>											
												<div className="row">
													<div className="col-xs-5" style={{paddingLeft:'37px'}}>
														<p className="" onClick={this.verDetallePagoPorKM.bind(this)}>
															<b style={{ 'color': 'rgb(255, 111, 32)' }}>{textoPagoPorKilometro}</b>
														</p>
													</div>
													{
														// enableFinalCapture || isEndKmCaptured
														false
														?
														 <div>
															<div className="col-xs-2">
															</div>
															<div className="col-xs-5" style={{paddingLeft:'30px'}}>
																{/* <p className="" onClick={() => this.verDetallePagoPorKMFinal(textoPagoPorKilometroFinal)}>
																	<b style={{ 'color': 'rgb(255, 111, 32)' }}>{textoPagoPorKilometroFinal}</b>
																</p> */}
																<p className="" onClick={() => this.verDetallePagoPorKMFinal(textoPagoPorKilometroFinal)}>
																	<b style={{ 'color': 'rgb(255, 111, 32)' }}>{"textoPagoPorKilometroFinal"}</b>
																</p>
															</div>
														</div> 
														: null
													}
												</div>
											</div>
										}
										<div className="clearfix no-poliza-movil icons-polizas-mobile botones-detalle">
											<div className="col-xs-6 text-center">
												<a onClick={this.toggleServicios}>
													<img src={require("../../img/user_copy.svg")} onLoad={this.cargarImagen.bind(this, "servicios")} alt="" />
													{/* {this.seccionVisible("servicio", "pagar") && this.mostrarPagar() && this.props.poliza.cobranza && this.props.poliza.cobranza.registros && this.props.poliza.cobranza.registros.length > 0 &&
														<div className="orange-notification">1</div>
													} */}
													<br />
													<small>Servicios</small>
												</a>
											</div>
											{!isSantander(this.props.poliza) && (
												<div className="col-xs-6 text-center">
													<a onClick={this.verPdf}>
														<img src={require("../../img/page_1_copy.svg")} onLoad={this.cargarImagen.bind(this, "descargas")} alt="" /><br />
														<small>Descargar</small>
													</a>
												</div>
											)}
										</div>
									</div>
								</div>
								<ul className={this.state.showServicios ? "movil-services" : "hide movil-services"}>
{/* 
									{this.seccionVisible("servicio", "pagar") && this.mostrarPagar() && this.props.poliza.cobranza && this.props.poliza.cobranza.registros && this.props.poliza.cobranza.registros.length > 0 ?
										<li className="card movil-service">
											<a onClick={this.showPago.bind(this)} >
												<span className="glyphicon glyphicon-triangle-top top-triangle"></span>
												<img src={require("../../img/icon-pagar.svg")} alt="" />
												<p>PAGAR PÓLIZA</p>
												<div className="orange-notification">1</div>
												<span className="glyphicon glyphicon-chevron-right"></span>
											</a>
										</li>
										:
										<li className="card movil-service">
											<a href={"tel:" + telPagar}>
												<span className="glyphicon glyphicon-triangle-top top-triangle"></span>
												<img src={require("../../img/icon-pagar.svg")} alt="" />
												<p>PAGAR PÓLIZA</p>
												<span className="glyphicon glyphicon-chevron-right"></span>
											</a>
										</li>
									} */}
									<li className="card movil-service">
										<a href={"tel:" + telConsultar}>
											<img src={require("../../img/icon-consulta.svg")} alt="" />
											<p>CONSULTA DE PÓLIZA</p>
											<span className="glyphicon glyphicon-chevron-right"></span>
										</a>
									</li>
									<li className="card movil-service">
										<a href={"tel:" + telSiniestros}>
											<img src={require("../../img/icon-siniestro.svg")} alt="" />
											<p>SEGUIMIENTO DE SINIESTRO</p>
											<span className="glyphicon glyphicon-chevron-right"></span>
										</a>
									</li>
									{this.state.productoAetna && 
									<li className="card movil-service">
										<a href={"tel:" + telAetnaEua}>
											<img src={require("../../img/user_copy.svg")} alt="" />
											<p>EMERGENCIA EN EUA</p>
											<span className="glyphicon glyphicon-chevron-right"></span>
										</a>
									</li>
									}
									{this.state.productoAetna && 
									<li className="card movil-service">
										<a href={"tel:" + telAetnaResto}>
											<img src={require("../../img/user_copy.svg")} alt="" />
											<p>EMERGENCIA RESTO DEL MUNDO</p>
											<span className="glyphicon glyphicon-chevron-right"></span>
										</a>
									</li>
									}
									{
										(
											ramo == "V" &&
													  (
														 cveProdTecnico == "V1011PFLVM" &&
																		 (cveProdComercial == "00002" ||  cveProdComercial == "00003" )  
													  )
											||	
											ramo == "G" &&
													(
													   cveProdTecnico == "G0300NAL01" 
													   ||
																		(cveProdTecnico == "G0334GMMII" && 
																		(cveProdComercial == "00001" || cveProdComercial == "00002" || 
														cveProdComercial == 	"00005" || cveProdComercial == "00006" ||
														cveProdComercial == 	"00007" || cveProdComercial == "00008" || 
																		 cveProdComercial == "00009" )  ) 
														||
																		(cveProdTecnico == "G0334GMMIN" && 
																		(cveProdComercial == "00001" || cveProdComercial == "00003" ||
																		cveProdComercial == "00004"  ||  cveProdComercial == "00005" ) ) 
													)
									 ) && 
										<li className="card movil-service">
										<a onClick={this.verServiciosMM}>
											<img src={require("../../img/user_copy.svg")} alt="" />
											<p>SERVICIOS MÉDICA MÓVIL</p>
											<span className="glyphicon glyphicon-chevron-right"></span>
										</a>
									</li>
								 }
								</ul>
							</div>
							{ 
								(/*ramo === "V" && this.props.SumaDentalia.numeroPoliza === this.props.poliza.generales.numPoliza
								 ||*/ ramo === "G" &&
								!this.props.PermisoDentalia.mensaje) ?
								<div className="cards-wrap contenedor-detalle" onClick={this.verAsistenciaDental} >
									<div className="row">
										<div className="card card-shadow" style={{ "margin": "-15px auto 0 auto", "width": "90%", "position": "relative" }} aria-hidden="false">
											<div className="detalle-poliza">
												<div className="clearfix no-poliza-movil">
													<div className="clearfix no-poliza-movil botones-detalle">
														<div className="col-xs-12 text-center">
															<img src={require("../../img/asistenciaDental_14p.svg")}  onLoad={this.cargarImagen.bind(this, "asistencias")} alt="" /><br />	
														</div>
													</div>
												</div>
											</div>							
										</div>
									</div>
								</div>:null
							}
						</div>
					}
				</div>

			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Detalle);


// WEBPACK FOOTER //
// ./src/movil/polizas/detalle.cmpt.js